import { render, staticRenderFns } from "./Politica.vue?vue&type=template&id=466dd8d8"
import script from "./Politica.vue?vue&type=script&lang=js"
export * from "./Politica.vue?vue&type=script&lang=js"
import style0 from "./Politica.vue?vue&type=style&index=0&id=466dd8d8&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports